import { useMemo } from 'react';

import type { UserGoal } from 'src/common/enums';
import type { Campaign } from 'src/common/interfaces/campaigns';
import { useGetUserQuery } from 'src/common/slices';

import { goalTitles } from './summer-deal.constants';
import { useGetSummerDealMetricsQuery } from './summer-deal.slice';

export const useCampaignCta = (campaign: Campaign | null): [string, string] => {
  const { data: userDataResponse } = useGetUserQuery();

  return useMemo(() => {
    if (userDataResponse?.data?.user?.isPremium) {
      return [`Switch to annual & save ${campaign?.amount}%`, '/manage-account/subscription'];
    }
    const isDiscountAvailable = campaign?.amount && campaign?.amount > 0;
    const label = isDiscountAvailable ? `Subscribe now & save ${campaign.amount}%` : 'Subscribe Now';

    return [label, '/why-subscribe'];
  }, [userDataResponse, campaign]);
};

export const useGoal = (): [UserGoal | null, string | null] => {
  const { data: userDataResponse } = useGetUserQuery();
  const goal = userDataResponse?.data?.user?.demographics?.goal;
  if (!goal) return [null, null];
  return [goal, goalTitles.get(goal) ?? null];
};

export const useSummerDealMetrics = () => {
  const { data: recapmeStatsResponse } = useGetSummerDealMetricsQuery();
  return recapmeStatsResponse?.data;
};
